/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/
import { useState } from 'react';
import FileCopyOutlined from '@material-ui/icons/FileCopyOutlined';
import { DocsTableRow } from '@backstage/plugin-techdocs';
import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Popover,
  Tooltip,
} from '@material-ui/core';
import ShareOutlinedIcon from '@material-ui/icons/ShareOutlined';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { shareViaMsTeams, shareViaOutlook } from '../../utils/constants';
import MsTeamsIcon from '../icons/MsTeamsIcon';

const createCopyDocsUrlAction = (copyToClipboard: Function) => {
  return (row: DocsTableRow) => {
    return {
      icon: () => <FileCopyOutlined fontSize="small" />,
      tooltip: 'Click to copy documentation link to clipboard',
      onClick: () =>
        copyToClipboard(`${window.location.origin}${row.resolved.docsUrl}`),
    };
  };
};

const ShareDocMenu = ({
  action,
  rowDetails,
}: {
  action: any;
  rowDetails: any;
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement>();
  const onClose = () => {
    setAnchorEl(undefined);
  };
  const onOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
    event.stopPropagation();
  };
  const url = `${window.location.origin}${rowDetails.resolved.docsUrl}`;
  const docsName = `${rowDetails.entity.metadata.title} Documentation`;
  const bodyText = `Hi, \nUse this link to view ${docsName}`;

  return (
    <>
      <Tooltip title="Click to share the documentation" arrow>
        <ShareOutlinedIcon
          aria-label="more"
          aria-controls="long-menu"
          aria-haspopup="true"
          aria-expanded={!!anchorEl}
          role="button"
          onClick={onOpen}
          data-testid="menu-button"
          id="long-menu"
        />
      </Tooltip>
      <Popover
        open={Boolean(anchorEl)}
        onClose={onClose}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        aria-labelledby="long-menu"
      >
        <MenuList autoFocusItem={Boolean(anchorEl)}>
          <MenuItem
            onClick={event => {
              event.stopPropagation();
              action(shareViaMsTeams, '', bodyText, url);
              onClose();
            }}
          >
            <ListItemIcon>
              <MsTeamsIcon />
            </ListItemIcon>
            <ListItemText primary="MS Teams" />
          </MenuItem>
          <MenuItem
            onClick={event => {
              event.stopPropagation();
              action(shareViaOutlook, docsName, bodyText, url);
              onClose();
            }}
          >
            <ListItemIcon>
              <MailOutlineIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="MS Outlook" />
          </MenuItem>
        </MenuList>
      </Popover>
    </>
  );
};

const shareDocsAction = (shareDocsMethod: any) => {
  return (row: DocsTableRow) => {
    return {
      icon: () => <ShareDocMenu action={shareDocsMethod} rowDetails={row} />,
      onClick: () => null,
    };
  };
};

export { createCopyDocsUrlAction, shareDocsAction };
